import Appsignal from "@appsignal/javascript";
import { plugin } from "@appsignal/plugin-path-decorator";

import { ENVIRONMENT, environment } from "@/lib/environment";

const ENVIRONMENT_TO_API_KEY: Record<ENVIRONMENT, string | undefined> = {
  development: import.meta.env.VITE_APPSIGNAL_DEV_API_KEY as string,
  test: undefined,
  staging: import.meta.env.VITE_APPSIGNAL_STAGING_API_KEY as string,
  production: import.meta.env.VITE_APPSIGNAL_PROD_API_KEY as string,
};

export const appsignal = new Appsignal({
  key: ENVIRONMENT_TO_API_KEY[environment],
  revision: import.meta.env.VITE_COMMIT_SHA as string | undefined,
});

appsignal.use(plugin());
